import Settings from '../components/settings/model/Settings';
import { SettingsActionTypeKeys } from './settingsActionTypes';

export const saveSettings = (settings: Settings)=> {
  return {
    settings,
    type: SettingsActionTypeKeys.SAVE_SETTINGS
  } as ISaveSettingsAction;
}

export interface ISaveSettingsAction {
  readonly type: SettingsActionTypeKeys.SAVE_SETTINGS;
  readonly settings: Settings;
}


// WEBPACK FOOTER //
// ./src/actions/settingsActions.ts